import { callWithNuxt } from '#app';
export default defineNuxtRouteMiddleware(async (to) => {
    const nuxtApp = useNuxtApp();
    const dash = useDashboardStore();
  const cookie = useCookie("userToken");

    if (process.client) {
        if (!cookie.value) {
            return callWithNuxt(nuxtApp, navigateTo, ['/authentication/login'])
        }
        if (!dash.getIsUserConnected) {
            await dash.fetchUserByToken()  
        }
        const orderId = to.query.orderId;

        if (!orderId) {
            console.warn("orderId not found in query params.");
            return callWithNuxt(nuxtApp, navigateTo, ['/error']);
        }

        const payment = await dash.getPaymentByOrderID(String(orderId));

        if (!payment || payment.data?.status !== 'pending') {
            return callWithNuxt(nuxtApp, navigateTo, ['/error']);
        }
        
    }



});
